module.exports = __webpack_public_path__ + "img/avatar.c1dd221f.svg";